export const getChangedFields = (fields, dirtyFields) => {
  return Object.entries(fields)
    .filter(([key, _]) => dirtyFields[key])
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
};